import React, { useState } from "react";
import { Collapse, IconButton, TableCell, TableRow } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { MaterialSpecificationViewModel } from "api/factories/creatives.factory";
import {
    CreativesSection,
    MaterialSpecRowBox,
    MaterialSpecRowDetailsBox,
    MaterialSpecsCards,
    MaterialSpecTableRow,
    MaterialSpecMenu,
} from "pages/MaterialSpecs/components";
import { getTokensMatSpecId } from "store/features/authorization";
import { useSelector } from "react-redux";
import { ButtonContainer } from "components";
import { LoadingOverlay } from "components/LoadingOverlay/LoadingOverlay";
import { getLineItemsRowById, getMaterialSpecUpdatingStatus } from "store/features/materialSpecs/specs";
import { useAlert } from "hooks";
import { MaterialSpecCell } from "pages/MaterialSpecs/components/MaterialSpecRow/MaterialSpecCell/MaterialSpecCell";
import { useTranslation } from "react-i18next";

interface MaterialSpecRowProps {
    row: MaterialSpecificationViewModel;
}

export const MaterialSpecRow = ({ row }: MaterialSpecRowProps) => {
    const { t } = useTranslation();
    const { toggleAlert } = useAlert();
    const matSpecId = useSelector(getTokensMatSpecId);
    const isMaterialSpecStatusUpdating = useSelector(getMaterialSpecUpdatingStatus(row.id));
    const [open, setOpen] = useState(row.id === matSpecId);
    const lineItemRow = useSelector(getLineItemsRowById(row.id));
    const arrivedMaterialsCount = row.materials.filter(({ status }) => status.text === "ARRIVED").length;

    if (!lineItemRow) {
        toggleAlert({ message: t("campaign.warnings.lineItemNotFound", { id: row.id }), type: "warning" });

        return null;
    }

    return (
        <>
            <MaterialSpecRowBox component={MaterialSpecTableRow} open={open} onClick={() => setOpen(!open)}>
                {lineItemRow.values.map((props, index) => {
                    return (
                        <TableCell key={`${props.value}_${index}`}>
                            <MaterialSpecCell {...props} />
                        </TableCell>
                    );
                })}
                <TableCell>
                    {arrivedMaterialsCount} {t("campaign.label.of")} {row.materials.length}
                </TableCell>
                <TableCell align="right">
                    <ButtonContainer paddingX={0.5}>
                        <MaterialSpecMenu materialSpecId={row.id} permissions={row.permissions} />
                        <IconButton disableRipple size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </ButtonContainer>
                </TableCell>
            </MaterialSpecRowBox>
            <MaterialSpecRowDetailsBox component={TableRow}>
                <MaterialSpecsCards colSpan={lineItemRow.values.length + 2}>
                    <LoadingOverlay active={isMaterialSpecStatusUpdating} visible={open}>
                        <Collapse in={open} timeout={300} mountOnEnter>
                            <CreativesSection
                                permissions={row.permissions}
                                statusCode={row.status.code}
                                printed={row.isPrinted}
                                materialSpecId={row.id}
                                adMaterials={row.materials}
                            />
                        </Collapse>
                    </LoadingOverlay>
                </MaterialSpecsCards>
            </MaterialSpecRowDetailsBox>
        </>
    );
};
